var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mdc-form-field mdc-radio-container" }, [
    _vm.leftLabel
      ? _c(
          "label",
          {
            staticClass:
              "typography--body-3 typography--color-secondary clickable",
            attrs: { id: _vm.id + "-left-label", for: _vm.id }
          },
          [_vm._t("left-label")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mdc-radio" }, [
      _c("input", {
        staticClass: "mdc-radio__native-control",
        attrs: { id: _vm.id, type: "radio" },
        domProps: { checked: _vm.state },
        on: { change: _vm.onChange }
      }),
      _vm._v(" "),
      _vm._m(0)
    ]),
    _vm._v(" "),
    !_vm.leftLabel
      ? _c(
          "label",
          {
            staticClass:
              "typography--body-3 typography--color-secondary clickable",
            attrs: { id: _vm.id + "-label", for: _vm.id }
          },
          [_vm._t("label")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mdc-radio__background" }, [
      _c("div", { staticClass: "mdc-radio__outer-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "mdc-radio__inner-circle" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-961ceb0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-961ceb0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radio.vue
// module id = EY1k
// module chunks = 1